import { Patient } from '.';

export interface IUser {
  id: string | number;
  firstName?: string;
  lastName?: string;
  email?: string;
  avatar?: string;
  locale?: string;
  patient: Patient;
}

export default class User implements IUser {
  id: string | number = '';
  firstName: string = '';
  lastName: string = '';
  email: string = '';
  avatar: string = '';
  locale: string = '';
  patient: Patient = new Patient({});
  constructor(obj: Partial<IUser>) {
    Object.assign(this, obj);
  }

  static createFromEntity(obj: Partial<any>) {
    return new User({
      id: obj.id,
      lastName: obj.name,
      firstName: obj.firstname,
      avatar: obj.avatar,
      locale: obj.locale,
      email: obj.email,
      patient: Patient.createFromEntity(obj.patient)
    });
  }

  copyWith(obj: Partial<IUser>) {
    return new User(Object.assign({}, this, obj));
  }

  getFullName() {
    return `${this.patient.firstName || ''} ${this.patient.lastName || ''}`;
  }

  getInitials() {
    return `${(this.patient.firstName || '')[0] || ''}${
      (this.patient.lastName || '')[0] || ''
    }`.toUpperCase();
  }
}
